var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "h3",
      { staticClass: "title", attrs: { content: "edit", placement: "bottom" } },
      [
        _vm._v("\n    Content Management - Generic Contents\n    "),
        _vm.$store.state.userLevel <= 2
          ? _c(
              "el-button",
              {
                staticStyle: { width: "180px" },
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.handleAdd()
                  }
                }
              },
              [_vm._v("Create")]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "client-panel" },
      [
        _c(
          "div",
          { staticClass: "client-panel__toolbar" },
          [
            _c("columns-control", {
              attrs: {
                columns: _vm.columnsConfig,
                "storage-key": "cms.genericContents.columns"
              },
              on: { change: _vm.onColumnsChange }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          { attrs: { data: _vm.tableData } },
          [
            _vm.isColumnVisible("id")
              ? _c("el-table-column", { attrs: { prop: "id", label: "Id" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("type")
              ? _c("el-table-column", {
                  attrs: { prop: "type", label: "Type" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("field")
              ? _c("el-table-column", {
                  attrs: { prop: "field", label: "Field" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("createdByName")
              ? _c("el-table-column", {
                  attrs: { prop: "createdByName", label: "Created By" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Operation" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "Edit",
                            placement: "top"
                          }
                        },
                        [
                          _c("em", {
                            staticClass: "edit",
                            staticStyle: { "margin-right": "10px" },
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.row)
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "Delete",
                            placement: "top"
                          }
                        },
                        [
                          _c("em", {
                            staticClass: "delete",
                            on: {
                              click: function($event) {
                                return _vm.handleDelete(scope.row)
                              }
                            }
                          })
                        ]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("app-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [5, 10, 20, 50],
            total: _vm.total,
            "page-size": _vm.currentSize
          },
          on: {
            "size-change": function(v) {
              _vm.currentSize = v
              _vm.currentPage = 1
              _vm.getContents()
            },
            "current-change": function(v) {
              _vm.currentPage = v
              _vm.getContents()
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ecd8838e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecd8838e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/genericContent/genericContent.vue
// module id = null
// module chunks = 